<template>
  <calm-page extra-class="payment" :title="$t('menu.payment')">
    <!-- ═══════════════ SEARCH BAR ═══════════════ -->
    <calm-filter-bar
      :search-label="$t('search')"
      :loading="isLoading"
      :show-reset="false"
      @search="listData(searchParams)"
    >
      <calm-field :label="$t('lmg.trans_date')">
        <flat-picker
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{ allowInput: true }"
          class="form-control datepicker calm-cal"
          v-model="searchParams.startDate"
        >
        </flat-picker>
      </calm-field>

      <calm-field :label="$t('lmg.trans_date')">
        <flat-picker
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{ allowInput: true }"
          class="form-control datepicker calm-cal"
          v-model="searchParams.endDate"
        >
        </flat-picker>
      </calm-field>

      <calm-field :label="$t('lmg.paid_status')">
        <el-select
          v-model="searchParams.cashClear"
          :placeholder="$t('lmg.paid_status')"
        >
          <el-option
            v-for="option in paidStatus"
            :key="option.ID"
            :label="option.Name"
            :value="option.ID"
          >
          </el-option>
        </el-select>
      </calm-field>

      <calm-field :label="$t('lmg.sort')">
        <el-select
          v-model="searchParams.sort"
          :placeholder="$t('lmg.sort')"
        >
          <el-option
            v-for="option in sort"
            :key="option.ID"
            :label="option.Name"
            :value="option.ID"
          >
          </el-option>
        </el-select>
      </calm-field>
    </calm-filter-bar>

    <!-- ═══════════════ TABLE (skin the existing el-table, §11) ═══════════════ -->
    <calm-table
      :total="total"
      :from="from"
      :to="to"
      :per-page.sync="pagination.perPage"
      :current-page.sync="pagination.currentPage"
      :per-page-options="pagination.perPageOptions"
      :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
      :count-label="$t('data')"
      :to-label="$t('to')"
      :of-label="$t('of')"
      :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
    >
      <template slot="toolbar">
        <input
          v-model="searchQuery"
          type="text"
          class="ed"
          :placeholder="$t('search')"
        />
      </template>

      <el-table
        :data="queriedData"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
        <el-table-column :label="$t(`lmg.recorder`)" min-width="200">
          <template slot-scope="{ row }">
            {{ row.RecordPersonFName }} {{ row.RecordPersonLName }}
          </template>
        </el-table-column>


        <el-table-column :label="$t(`lmg.amount`)" min-width="200">
          <template slot-scope="{ row }">
            {{ FormatCurrency(row.Amount) }}
          </template>
        </el-table-column>

        <el-table-column :label="$t(`lmg.payment_method`)" min-width="200">
          <template slot-scope="{ row }">
            {{ getPaidType(row.PaidVia) }}
          </template>
        </el-table-column>

        <el-table-column :label="$t(`lmg.bank`)" min-width="200">
          <template slot-scope="{ row }">
            {{ row.BankName }}
          </template>
        </el-table-column>

        <el-table-column :label="$t(`lmg.cash_clear`)" min-width="200">
          <template slot-scope="{ row }">
            <span class="payment__pill payment__pill--cash">
              {{ getClashClearName(row.CashClear) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t(`lmg.payment_source`)" min-width="200">
          <template slot-scope="{ row }">
            <!-- Quick-payment-created invoices carry source=2 AND a real invoice
                 number (they show in the invoice list). Show BOTH the channel pill
                 and the number so a payment can be traced back to its วางบิล. -->
            <div class="payment__source">
              <span
                v-if="Number(row.InvoiceSource) === 2"
                class="payment__pill payment__pill--branch"
              >
                {{ $t('lmg.paid_at_branch') }}
              </span>
              <span v-if="row.InvoiceNumber" class="payment__source-no">
                ใบวางบิล {{ row.InvoiceNumber }}
              </span>
              <span
                v-if="!row.InvoiceNumber && Number(row.InvoiceSource) !== 2"
                class="payment__source-muted"
              >-</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t(`lmg.trans_date`)" min-width="200">
          <template slot-scope="{ row }">
            {{ row.CreatedAt }}
          </template>
        </el-table-column>

        <el-table-column :label="$t(`actions`)" min-width="200px">
          <template slot-scope="{ row }">

            <!-- show billing -->
            <!-- show image -->
            <div class="payment__rowact">
              <calm-button
                variant="ghost"
                size="sm"
                icon-only
                @click="handleTransactionDetail( row)"
                :title="$t('menu.trans')"
              >
                <i class="fa fa-list"></i>
              </calm-button>

              <calm-button
                variant="ghost"
                size="sm"
                icon-only
                @click="handleShowImage(row)"
                v-if="row.TfImage != ''"
              >
                <i class="fas fa-image"></i>
              </calm-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </calm-table>


<!-- ----------------------- Modal Create Payment ----------------------- -->
    <modal :show.sync="showAddModal" modal-classes="modal-secondary" custom-class="calm__dialog calm">
       <h1>{{ $t("lmg.payment_create") }}</h1>
      <form class="new-event--form" @submit.prevent="saveEvent">

        <base-input
          :label="$t('lmg.billing_paid_via')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select
            v-model="md.paidVia"
            :placeholder="$t('lmg.billing_paid_via')"
          >
            <el-option
              v-for="option in paidType"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>
        <base-input
          :label="$t('lmg.billing_note')"
          v-model="md.Note"
        ></base-input>

        <base-input
          :label="$t('lmg.bank')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select v-model="md.bankID" :placeholder="$t('lmg.bank')">
            <el-option
              v-for="option in tableBank"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>
        <form>
          <base-input
            :label="$t('lmg.paid_file')"
            input-classes="form-control-alternative new-event--title"
          >
            <file-input @change="filesChange"></file-input>
          </base-input>
        </form>
        <!-- <base-input :label="$t('billing.note')" v-model="md.note"></base-input>
        <base-input :label="$t('billing.note')" v-model="md.note"></base-input> -->

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

<!-- ----------------------- Modal Image Payment ----------------------- -->
    <modal :show.sync="showImageModal" modal-classes="modal-secondary modal-lg" custom-class="calm__dialog calm">
       <h1>{{ $t("lmg.payment_image") }}</h1>

      <div class="pay-gallery">
        <img v-for="(src, i) in payment_images" :key="i" :src="src" class="pay-gallery__img" />
        <p v-if="!payment_images.length" class="text-muted text-center">{{ $t("lmg.no_attachments") }}</p>
      </div>


      <template slot="footer">
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showImageModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>


    <!-- ------------------------  Modal Detail  ------------------------ -->
    <modal
      :show.sync="showTransactionDetailModal"
      modal-classes="modal-secondary modal-lg"
      custom-class="calm__dialog calm"
    >
     <h1>{{ $t("lmg.trans_detail") }} : {{ trans.ID }}</h1>
      <!-- recorder owner person customer -->
      <div class="row">
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.recorder')"
            :value="trans.RecordPersonFName + '  ' + trans.RecordPersonLName"
          ></base-input>
        </div>
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.owner_person')"
            :value="trans.OwnerPersonFName + '  ' + trans.OwnerPersonLName"
          ></base-input>
        </div>
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.customer')"
            :value="trans.CustomerFname + '  ' + trans.CustomerLname"
          ></base-input>
        </div>
      </div>

      <!-- ttype comprofile amount -->
      <div class="row">
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.amount')"
            :value="trans.Amount"
          ></base-input>
        </div>
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.ttype')"
            :value="trans.TransactionTypeName"
          ></base-input>
        </div>
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.comm')"
            :value="trans.ComProfileName"
          ></base-input>
        </div>
      </div>

      <!-- initial com  payment pay  , amount-->
      <!-- policy number , licentpage -->
      <div class="row">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.payment_comm')"
            :value="trans.InitialCom"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.payment_amount')"
            :value="trans.InitialPayment"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.policy_number')"
            :value="trans.PolicyNumber"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.license_plate')"
            :value="trans.LicencePlate"
          ></base-input>
        </div>
      </div>

      <!-- start , end  note -->
      <div class="row">
        <div class="col-lg-6">
          <base-input
            :label="$t('lmg.protection_date')"
            :value="trans.StartDate + ' - ' + trans.EndDate"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('status')"
            value="สำเร็จ"
            v-if="trans.Status == 1"
          ></base-input>
          <base-input
            :label="$t('status')"
            value="กำลังดำเนินการ"
            v-if="trans.Status == 2"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.trans_date')"
            :value="trans.CreatedAt"
          ></base-input>
        </div>
      </div>

      <!-- สถานะการเงิน / cash not clear -->
      <!-- created date / status -->
      <div class="row">
        <div class="col-lg-6">
          <base-input :label="$t('lmg.note')" :value="trans.Note"></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.cash_clear')"
            value="ไม่มีเงินสดค้างที่พนักงาน"
            v-if="trans.CashClear == 1"
          ></base-input>
          <base-input
            :label="$t('lmg.cash_clear')"
            value="มีเงินสดค้าง"
            v-if="trans.CashClear == 2"
          ></base-input>
          <base-input
            :label="$t('lmg.cash_clear')"
            value="ไม่ใช้เงินสด ไม่มีเงินค้าง"
            v-if="trans.CashClear == 3"
          ></base-input>
        </div>
        <div class="col-lg-3" v-if="trans.CashClear == 2">
          <base-input
            :label="$t('lmg.cash_clear_amount')"
            :value="trans.CashNotClearAmount"
          ></base-input>
        </div>
      </div>

      <template slot="footer">
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showTransactionDetailModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </calm-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  mixins: [clientPaginationMixin],
  components: {
    flatPicker,
    BasePagination,
    RouteBreadCrumb,
    FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "Payment/getData",
      tableBank: "Bank/getData",
      getClashClearName: "Payment/getCashClearName",
      getPaymentImageURL: "Payment/getPaymentImageURL",
      tableTrans: "Transaction/getData",
      isLoading: "Payment/isLoading",
    }),
     trans : function(){
       if (this.tableTrans.length > 0)
        return this.tableTrans[0]
        else 
        return {

        }

    },
    tableData: function() {
      // console.log(this.$route.query.id);
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m) => {
      //     return m.EnterpriseID == "" + this.$route.query.id;
      //   });
      // }

      return this.tableDataOrg;
    }
  },
  data() {
    return {
      // Fields the in-table ค้นหา box matches against (Fuse keys). Payment rows
      // carry no Name/AcountNumber — search by invoice no., policy no., the
      // customer/agent names and the bank so staff can find a row (e.g. by
      // invoice number "48/06/69").
      propsToSearch: [
        "InvoiceNumber",
        "PolicyNumber",
        "CustomerFname",
        "CustomerLname",
        "OwnerFname",
        "OwnerLname",
        "BankName",
        "RecordPersonFName",
        "RecordPersonLName",
      ],
      selectedRows: [],
      showAddModal: false,
      showImageModal: false,
      showTransactionDetailModal : false,
      searchParams: {
        startDate: "",
        endDate: "",
        sort: 1, //1=DESC
        tID: 0, // TransactionID
        cashClear: 0 // 0 = all , 1= จ่ายแล้ว 2 = ยังไม่ได้จ่าย
      },
      detail: {},
      payment_images: [],
      md: {
        billID: "",
        paidVia: 1,
        Note: "",
        billFile: "",
        bankID: ""
      },

      paidType: [
        { ID: 1, Name: "เงินสด" },
        { ID: 2, Name: "เช็ค" },
        { ID: 3, Name: "โอนเงิน" }
      ],
      paidStatus: [
        { ID: 0, Name: "All" },
        { ID: 1, Name: "จ่ายแล้ว" },
        { ID: 2, Name: "ยังไม่จ่าย" }
      ],
      sort: [
        { ID: 0, Name: "วันที่ล่าสุด" },
        { ID: 1, Name: "วันที่เริ่มต้น" }
      ]
    };
  },
  async mounted() {
    const now = new Date();
    const pad = (n) => (n < 10 ? "0" + n : "" + n);
    const y = now.getFullYear();
    const m = pad(now.getMonth() + 1); // +1 — getMonth() is 0-indexed
    this.searchParams.startDate = `${y}-${m}-01`;
    this.searchParams.endDate = `${y}-${m}-${pad(now.getDate())}`;
    await this.listData(this.searchParams);
    await this.listBank();

    this.md.bankID = this.tableBank[0].ID;

  },
  methods: {
    ...mapActions({
      createData: "Payment/createData",
      listData: "Payment/listData",
      listBank: "Bank/listData",
      getPaymentImage : "Payment/getPaymentImage",
      getPaymentImage2 : "Payment/getPaymentImage2",
      getPaymentAttachments : "Payment/getPaymentAttachments",
      getPaymentAttachment : "Payment/getPaymentAttachment",
      listTransaction: "Transaction/listData",
    }),
    getPaidType(t) {
      let s =  this.paidType.filter(f => {
        return f.ID == t;
      });

      return s.length != 0 ? s[0].Name : "-"
    },
    getPaidStatus(t) {
      let s =  this.paidStatus.filter(f => {
        return f.ID == t;
      });
      return s[0].Name
    },
    async handleShowImage(row){
      this.detail = row
      this.payment_images = []
      this.showImageModal = true
      try {
        // New path: list attachment rows for this payment and fetch each as base64.
        const list = await this.getPaymentAttachments(row.ID)
        if (list && list.length) {
          const imgs = await Promise.all(
            list.map((att) => this.getPaymentAttachment(att.id))
          )
          this.payment_images = imgs
          return
        }
      } catch (err) {
        console.log(err)
      }
      // Fallback: legacy single tf_image so old rows still show.
      try {
        const res = await this.getPaymentImage(row.ID)
        const buffer = Buffer.from(res.data).toString('base64')
        this.payment_images = ["data:" + res.headers["content-type"] + ";base64," + buffer]
      } catch (err) {
        console.log(err)
        this.payment_images = []
      }
    },
     handleTransactionDetail(row){
      this.showTransactionDetailModal = true;
      this.listTransaction({tID: row.TID})
    },
    handlePayment(row) {
      this.showAddModal = true;
      this.md.ID = 0;
      this.md.billID = row.ID;
      this.md.paidVia = 1;
      this.md.Note = "";
    },
    handleUpdate() {
      this.showAddModal = false;

        let formData = new FormData();
        formData.append("billID", this.md.billID);
        formData.append("paidVia", this.md.paidVia);
        formData.append("note", this.md.Note);
        formData.append("tfimg", this.md.billfile);
        formData.append("bankID", this.md.bankID);

        this.createData(formData)
          .then(resp => {
            this.listData(this.searchParams);
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    filesChange(files) {
      this.md.billfile = files[0];
    }
  }
};
</script>
<style scoped>
/* multi-attachment gallery (image modal) — scrollable stack of proofs */
.pay-gallery { max-height: 70vh; overflow-y: auto; }
.pay-gallery__img { display: block; width: 100%; margin-bottom: 12px; border-radius: 6px; }

/* Payment list — Calm skin. Namespaced under .payment so nothing leaks to
   other pages. The el-table is kept verbatim (§11 "skin, don't rewrite") and
   re-styled only via deep selectors. The create/image/detail modals stay on
   the existing Argon <modal> (custom-class="calm__dialog calm") so the
   file-upload + image-preview mechanics are untouched. */

/* Row-action cell: keep the icon buttons inline. */
.payment__rowact {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

/* Cash-clear status as a calm presentation pill (no logic change). */
.payment__pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 13px;
  line-height: 1.4;
}
.payment__pill--cash {
  background: var(--c-blue-soft, #ebf2fa);
  color: var(--c-blue-deep, #2c5282);
}
.payment__pill--branch {
  background: var(--c-green-soft, #e7f6ec);
  color: var(--c-green-deep, #276749);
}

/* Source cell stacks the channel pill above the invoice number. */
.payment__source {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
}
/* Source = regular invoice number, shown mono like other policy/number cells. */
.payment__source-no {
  font-family: "SFMono-Regular", "Menlo", "Consolas", monospace;
  font-size: 13px;
  color: var(--c-text, #2c3e50);
}
.payment__source-muted {
  color: var(--c-text-soft, #98a4b3);
}

/* The free-text search box reuses the Kit's .ed input look. */
.payment >>> .ed {
  width: 240px;
  max-width: 100%;
}

/* Skin the existing <el-table> so it reads as a Calm surface without touching
   any column definitions or slots (§11). Deep selectors only. */
.payment >>> .el-table {
  color: var(--c-text, #2c3e50);
  background: transparent;
}
.payment >>> .el-table th,
.payment >>> .el-table .thead-light th {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
  font-weight: 600;
  border-bottom: 1px solid var(--c-border, #e3e9f0);
}
.payment >>> .el-table td {
  border-bottom: 1px solid var(--c-border, #eef2f7);
}
.payment >>> .el-table::before {
  background: var(--c-border, #e3e9f0);
}
.payment >>> .el-table__row:hover > td {
  background: var(--c-surface-soft, #f7fafd) !important;
}
</style>
